/* eslint-disable react-hooks/exhaustive-deps */
import { ContextMenuContentProps, MenuDivider, MenuItem } from "@blueprintjs/core" 
import { useEffect, useState } from "react"
import { __, } from "../utilities"
import { useNavigate } from "react-router"
import { IState, IUser, useMainStore } from "@/settings/zustand"
import { moduleExists, profile } from "../layouts"
import { IMenuItem } from "../interfaces/layouts"
import { isRole } from "@/settings/zustand/user"
import DayNightSwitcher from "src/modules/pe-basic-module/widgets/DayNightSwitcher"

export const MENU_ITEM_ICON_DIVIDER = "--icon--"
export const MENU_ITEM_WIDGET = "--widget--"
export const MENU_ITEM_DIVIDER = "--divider--"
interface IExtendsProps {
    menuProps : ContextMenuContentProps
    contextMethods?: any
}
const ExtendMenu = ({menuProps}: IExtendsProps) :JSX.Element => { 
    return (
        <>
            {/**/} 
            <MenuDivider />
            <ExtendedMenus {...{menuProps}} />
            <CopyTextMenuItem {...{menuProps}} />
            <PasteTextMenuItem {...{menuProps}} /> 
            
        </>
    )
}  
export default ExtendMenu

export const CopyTextMenuItem = ({menuProps}: IExtendsProps) :JSX.Element => {
    const [text, setText] = useState<string | null>(null)
    useEffect(
        () => {
            const target : any = menuProps.mouseEvent?.target
            var selObj = window.getSelection();
            var selRange = selObj && !!selObj.rangeCount ? selObj.getRangeAt(0) : "" 
            if( 
                target instanceof HTMLInputElement ||
                target instanceof HTMLTextAreaElement ||
                target instanceof HTMLSelectElement ||
                !!target
            ) {
                setText( target.value ) 
            }   
            else if( selRange ) {
                setText( selRange.toString() )
            }       
            else {
                setText( target ? ( target as HTMLElement )?.innerText : null ) 
            } 
            
        }, 
        [ menuProps.mouseEvent?.target ]
    )
    const onClick = () => { 
        try {
            if( text ) {
                navigator.clipboard.writeText(text);
            } 
          } 
          catch (err) 
          {
            console.error('Failed to copy: ', err);
          }
    }
    return text
        ? 
        <MenuItem 
            label={ __("Copy") } 
            text={ __(text) } 
            textClassName="w_250 text-overflow" 
            icon="clipboard" 
            onClick={onClick}
        /> 
        : 
        <></>
}
export const PasteTextMenuItem = ({menuProps}: IExtendsProps) :JSX.Element => {
    const [text, setText] = useState<JSX.Element>( <></> )
    const onClick = () => {
        const target : any = menuProps.mouseEvent?.target
        if(!!target || target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)
        {
            navigator.clipboard.readText()
                .then(text => {
                    target.setAttribute('data-pasted', 'pasted');
                    //target.value = target.value + text 
                    const tg: any = document.querySelector('[data-pasted="pasted"]');
                    //console.log( tg )
                    //console.log( text )
                    Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')!.set!.call(tg, text.toString());
                    tg.dispatchEvent( new Event('change', { bubbles: true } ) )
                    tg.removeAttribute('data-pasted');
                })
                .catch(err => { 
                    console.log('Something went wrong', err); 
                })
               
        }
    }
    useEffect(
        () => {
            const target : any = menuProps.mouseEvent?.target
            if(!!target || target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)  
            {
                navigator.clipboard.readText()
                    .then(text => {
                        setText(<MenuItem 
                            text={ __("Paste from Clipboard") } 
                            textClassName="w_250 text-overflow" 
                            icon="arrow-bottom-right" 
                            onClick={onClick}
                        />)
                    })
                    .catch(err => {
                        // возможно, пользователь не дал разрешение на чтение данных из буфера обмена
                        console.log('Something went wrong', err);
                        setText(<MenuItem 
                            text={ __("Paste from Clipboard") } 
                            textClassName="w_250 text-overflow" 
                            icon="arrow-bottom-right" 
                            onClick={onClick}
                        />)
                    })
            }
        }, 
        [ menuProps.mouseEvent?.target ]
    )
    return text
}

export const ExtendedMenus = ({menuProps, contextMethods}: IExtendsProps) :JSX.Element => { 
    const target : any = menuProps.mouseEvent?.target
    // console.log( target.closest('[context-title]') )
    if(!target ||  (!!target && !target.getAttribute('context-title') && !target.closest('[context-title]')) ) {
        return <UserMenu />
    }
    
    const element = target.getAttribute('context-title') ? target : target.closest('[context-title]')
    if( !!element )  
    {
        return <>
            {
                element.getAttribute('context-title')?.split("|||")
                    .map((title: string) => <SingleExtendedMenu label={ title } contextMethods={ contextMethods } key={title} />)
            }
            <MenuDivider />
        </>
    } 
    return <UserMenu />
}

interface  ISingleProps {
    label: string
    contextMethods: any
}
export const SingleExtendedMenu = ({ label, contextMethods }:ISingleProps) : JSX.Element => {
    const menus: string[] = label.split("||")
    if( !menus.length ) {
        return <></>
    }
    return menus[0].indexOf(MENU_ITEM_WIDGET) === 0
        ? 
        <ExtendedMenuWidget contextMethods={contextMethods} menus={menus} />
            :
            menus[0].indexOf(MENU_ITEM_DIVIDER) === 0
                ?
                <MenuDivider />
                :
                <ExtendedMenuItem contextMethods={contextMethods} menus={menus} />
    
}

export const ExtendedMenuItem = ({ menus, contextMethods, ...props}: any) : JSX.Element => {
    const onClick = ( elementData: string[] ) => {        
        // console.log( elementData, contextMethods )    
        const method: string    = elementData[2]
        if(!!method) {
            const args: string[]    = elementData[3].split(".")
            contextMethods[method](...args)
        }
    }
    const btnData = menus[0].split(MENU_ITEM_ICON_DIVIDER)
    
    return menus.length > 1
        ?
        <MenuItem text={ __( btnData[0] )} icon={ btnData[1] as any || "blank" }>
            {
                menus.splice(1).map(( title: string ) => {
                    const titleData = title.split(MENU_ITEM_ICON_DIVIDER)
                    if( title.indexOf(MENU_ITEM_WIDGET) === 0 ) {
                        //return <div>{titleData[1]} :: {titleData[2]}</div>
                        return <ExtendedMenuWidget contextMethods={contextMethods} menus={[title]} />
                    }
                    else if( title.indexOf(MENU_ITEM_DIVIDER) === 0 ) {
                        return <MenuDivider />
                    }
                    else { 
                        return <MenuItem 
                            key={ titleData[0] }
                            text={ __(titleData[0]) } 
                            textClassName="w_250 text-overflow" 
                            icon={ ( titleData[1] as any ) || "blank"} 
                            onClick={() => onClick( titleData )}
                        />
                    }
                })
            }
        </MenuItem>
        :
        <MenuItem text={__(btnData[0]) } icon={ btnData[1] as any || "blank" }  onClick={() => onClick( btnData )}/>
}

export const ExtendedMenuWidget = ({contextMethods, menus, ...props}: any) : JSX.Element => { 
    const btnData = menus[0].split(MENU_ITEM_ICON_DIVIDER)
    const widget_type = btnData[1]
    if(!contextMethods[ widget_type ]) {
        return <></>
    }
    const args: string[]    = btnData[2].split(".")
    return contextMethods[ widget_type ]( ...args )
}

export const UserMenu = () : JSX.Element => {
    const navigate      = useNavigate()
    const user: IUser   = useMainStore((state: IState) => state.user )
    const menus         = user.id 
        ? 
        profile()
            .filter((m:IMenuItem) => {
                return (!m.is_hidden && moduleExists( m.module ) &&  isRole( m.capability || [] )) || !Array.isArray(m.capability)
            })
        :
        []
    if(!!menus.length)
    {
        return <>
            {
               menus.map( (m:IMenuItem) => {
                    return <MenuItem 
                        text={ __(m.title) } 
                        onClick={() => navigate(`/${ m.route }`)} 
                        icon="blank"  
                        key={m.id}
                    /> 
                }) 
            }
            <MenuDivider /> 
            <DayNightSwitcher type="buttons" className=" text-force-contrast "/>
            <MenuDivider />
        </>
    }
    else{
        return <></>
    }
}
